module.exports = __webpack_public_path__ + "img/gen-z-vs-pandemic.d7b4be6d.png";